import { createSelector } from 'reselect';

/**
 * Direct selector to the currentUser state domain
 */
const selectCurrentUserDomain = (state) => state.get('currentUser');

/**
 * Other specific selectors
 */

/**
 * Default selector used by App
 */
const selectCurrentMe = createSelector(
  selectCurrentUserDomain,
  (substate) => substate.get('me') && substate.get('me').toJS()
);

const makeSelectCurrentUser = () => createSelector(
  selectCurrentUserDomain,
  (substate) => substate.toJS(),
);

export default makeSelectCurrentUser;
export {
  selectCurrentUserDomain,
  selectCurrentMe,
};
